class GccApiForbiddenError extends Error {
  constructor() {
    super('GccApiClient: Forbidden');
  }
}

export default GccApiForbiddenError;
